import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useChartData } from '../../../context/ChartContext';
import { useActiveSpectrum } from '../../../hooks/useActiveSpectrum';
import { PhaseTraceWithMouse } from './PhaseTraceWithMouse';
import { SpectraPhaseTraces } from './SpectraPhaseTraces';
export function PhaseTraces() {
    const { width, height, margin, displayerKey } = useChartData();
    const activeSpectrum = useActiveSpectrum();
    if (!activeSpectrum?.id || !width || !height)
        return null;
    const clipWidth = width - margin.left - margin.right;
    const clipHeight = height - margin.top - margin.bottom;
    return (_jsxs("svg", { viewBox: `0 0 ${width} ${height}`, width: width, height: height, style: {
            position: 'absolute',
            zIndex: 9,
        }, children: [_jsx("defs", { children: _jsx("clipPath", { id: `${displayerKey}-clip-phase-traces`, children: _jsx("rect", { width: clipWidth, height: clipHeight, x: margin.left, y: margin.top }) }) }), _jsxs("g", { clipPath: `url(#${displayerKey}-clip-phase-traces)`, children: [_jsx(PhaseTraceWithMouse, {}), _jsx(SpectraPhaseTraces, {})] })] }));
}
